export default {
  setLocation(state, location) {
    state.latitude = location.latitude;
    state.longitude = location.longitude;
    state.accuracy = location.accuracy;
  },
};
